import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=74e6bfaa&"
import script from "./Timeline.vue?vue&type=script&lang=js&"
export * from "./Timeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andy1229/專案/vue_後端網頁介面參考/研訊/shopstore_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74e6bfaa')) {
      api.createRecord('74e6bfaa', component.options)
    } else {
      api.reload('74e6bfaa', component.options)
    }
    module.hot.accept("./Timeline.vue?vue&type=template&id=74e6bfaa&", function () {
      api.rerender('74e6bfaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/components/Timeline.vue"
export default component.exports